__webpack_require__.p = "/فيلا ايليت/_next/";